// componente che intercetta tutte le richieste HTTP che escono dall'applicativo e inserisce nell'header
// della richiesta il token JWT precedentemente ricevuto dal back-end in caso di login

import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../service/authentication.service';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AuthenticationService
    ) {
    }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.authenticationService.getAccessToken();
        var me = this
        if (token && !request.url.endsWith('/signin')) {
            request = request.clone({
                setHeaders: {
                    Authorization: me.authenticationService.getAccessToken()
                }
            });
        }
        return next.handle(request);
    }

}
